var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 17.9679C7.5 12.1881 12.188 7.5 17.9679 7.5C23.7477 7.5 28.4358 12.1881 28.5 17.9679C28.5 22.5917 25.5458 26.5092 21.3715 27.922C20.8578 27.9862 20.6651 27.6651 20.6651 27.4083V24.5184C20.6651 23.555 20.3441 22.9128 19.9587 22.5917C22.2707 22.3349 24.711 21.5 24.711 17.4541C24.711 16.2982 24.2615 15.3349 23.6193 14.6284C23.6243 14.6083 23.6314 14.5829 23.6398 14.5527C23.7381 14.1981 24.0234 13.1688 23.4908 11.867C23.4908 11.867 22.5917 11.6101 20.6009 12.9587C19.7661 12.7661 18.8669 12.6376 17.9679 12.6376C17.0688 12.6376 16.1698 12.7018 15.3349 12.9587C13.344 11.6101 12.4449 11.867 12.4449 11.867C11.8774 13.2544 12.2387 14.3322 12.3128 14.553L12.3165 14.5642C11.6101 15.3349 11.2247 16.2339 11.2247 17.3899C11.2247 21.4358 13.6652 22.3349 15.9771 22.5917C15.7202 22.8486 15.3991 23.2982 15.3349 24.0046C14.7569 24.2615 13.2798 24.711 12.3165 23.1055C12.3165 23.1055 11.7385 22.078 10.711 22.0138C10.711 22.0138 9.68352 22.0138 10.6468 22.656C10.6468 22.656 11.3532 22.9771 11.8027 24.1973C11.8027 24.1973 12.4449 26.2523 15.3349 25.6101V27.4083C15.3349 27.6651 15.1422 27.9862 14.6285 27.922C10.5183 26.5092 7.5 22.5917 7.5 17.9679Z",
    fill: "#8ABE84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.b9008df8c4134841dff2300540ee4ac8.svg";
export { ForwardRef as ReactComponent };